// Compatibilité React 19.1 : callback stable, valeur mise à jour après commit.
import {useLayoutEffect,useRef,useCallback} from 'react';
export function useEffectEvent<T extends (...args:any[])=>any>(handler:T):T {
 const ref=useRef(handler);useLayoutEffect(()=>{ref.current=handler});
 return useCallback(((...args:Parameters<T>)=>ref.current(...args)) as T,[]);
}
